'use strict';

var _ = require('lodash');
var CompetitorFaresChartPanelController = function CompetitorFaresChartPanelController($scope, $q, $filter, competitorFaresChartDataProviderService, constants, competitorFaresChartFormattersService, profileChartDataProviderService) {
  $scope.chartData = {
    isLegendCollapsible: false,
    legendItems: []
  };
  $scope.selectedServices = [];
  $scope.legendFilter = [];
  $scope.filter = {
    mode: null,
    stops: 'all',
    display: $scope.screen === constants.FLIGHT_SCREEN ? 'timeWindowCompFares' : 'lowestCompFares',
    matchType: {
      fare: false,
      time: false
    }
  };
  function getFilterMode() {
    return $scope.filter.mode;
  }
  $scope.chartFormatters = competitorFaresChartFormattersService.getChartFormatters(getFilterMode);
  $scope.chartFormatters.tooltipFormatter.cssClass = 'competitor-fares-chart-tooltip ' + $scope.mode;
  $scope.resetFilters = function () {
    $scope.legendFilter = [];
    $scope.filter.matchType = {};
    $scope.selectedServices = [];
  };
  $scope.reloadChart = function (ignoreLegend) {
    return competitorFaresChartDataProviderService.getData({
      screen: $scope.screen,
      mode: $scope.mode,
      filter: $scope.filter,
      legendFilter: $scope.legendFilter,
      selectedEntity: $scope.selectedEntity,
      selectedServices: $scope.selectedServices,
      reorderCarriers: true
    }).then(function (chartData) {
      $scope.chartData.data = chartData.data;
      $scope.chartData.verticalLineData = chartData.verticalLineData;
      $scope.chartData.timeWindowLabel = chartData.timeWindowLabel;
      if (!ignoreLegend) {
        $scope.chartData.legendItems = chartData.legendItems;
        $scope.chartData.isLegendCollapsible = chartData.isLegendCollapsible;
      }
    }).then(function () {
      if ($scope.screen !== constants.FLIGHT_SCREEN) {
        return;
      }
      // update primaryEntity so on expanding it will be always be up to date
      profileChartDataProviderService.getCurveData({
        screen: $scope.screen,
        mode: $scope.mode,
        selectedMetric: $scope.metrics.metricList[0],
        subMode: 'flight-cabin-profile-mode',
        target: 'flight-profile-chart',
        showCapacity: false,
        legendFilter: []
      }).then(function (chartData) {
        $scope.primaryEntity = chartData.entity;
      });
    });
  };
  $scope.quickFilterUpdatedCallback = function () {
    $scope.legendFilter = [];
    $scope.reloadChart();
  };
  $scope.legendItemsCallback = function (data) {
    if (data.selected) {
      _.pull($scope.legendFilter, data.id);
    } else {
      $scope.legendFilter.push(data.id);
    }
    $scope.reloadChart(true);
  };
};
CompetitorFaresChartPanelController.$inject = ['$scope', '$q', '$filter', 'CompetitorFaresChartDataProviderService', 'DataRetrieverConstantsService', 'CompetitorFaresChartFormattersService', 'ProfileChartDataProviderService'];
module.exports = CompetitorFaresChartPanelController;